import React, { useEffect } from 'react'
import { MaskedTextInput, Tooltip } from '@paypalcorp/pp-react'
import { trackClick, trackError } from 'ppbl/utils/fpti-helper'

const MaskedTextInputAdapter = ({
  input,
  meta,
  toolTip,
  fptiPage,
  ...rest
}) => {
  const ToolTipIcon = (
    <Tooltip name="masked-input-tooltip" description={toolTip} />
  )

  const handleChange = (value, unmaskedValue, typedValue) => {
    input.onChange(value)
  }

  const handleFocus = () => {
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackError({
        page: fptiPage,
        error: meta.error,
        component: input.name,
        link: input.name,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <MaskedTextInput
      {...input}
      {...rest}
      onAccept={handleChange}
      {...(toolTip
        ? {
            rightIcon: ToolTipIcon,
          }
        : {})}
      errorText={meta.touched ? meta.error : ''}
      onFocus={handleFocus}
    />
  )
}

export default MaskedTextInputAdapter
